/** @format */

export const infoSummaryAttribute = {
	ids: ['2571', '2617', '2527', '1511', '2568', '2567', '2564', '5576', '1739'],
	values: ['Mountain', 'Sleeping Bags', 'Tents']
} as const;
